import { getTrialDaysRemaining, isTrialActive } from '@fsp/shared';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const URGENT_THRESHOLD_DAYS = 7;

export const FreeTrialBanner: React.FC = () => {
  const { currentOrganisation } = useAuth();
  const navigate = useNavigate();

  if (!currentOrganisation) return null;
  if (!isTrialActive(currentOrganisation)) return null;

  const daysRemaining = getTrialDaysRemaining(currentOrganisation);
  const isUrgent = daysRemaining <= URGENT_THRESHOLD_DAYS;

  return (
    <Box
      onClick={() => navigate('/settings/subscription')}
      sx={{
        bgcolor: isUrgent ? 'warning.main' : '#1a1a2e',
        color: 'common.white',
        py: 0.75,
        px: 2,
        textAlign: 'center',
        cursor: 'pointer',
        '&:hover': {
          bgcolor: isUrgent ? 'warning.dark' : '#2d2d44',
        },
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600, letterSpacing: 0.5 }}>
        FREE TRIAL — Expires in {daysRemaining} {daysRemaining === 1 ? 'day' : 'days'}.{' '}
        <Typography
          component="span"
          variant="body2"
          sx={{ textDecoration: 'underline', fontWeight: 600 }}
        >
          Click here to upgrade
        </Typography>
      </Typography>
    </Box>
  );
};
